const names = {
  // keep the basics
  transparent: 0,
  white: 4294967295,
  black: 255
};
if (process.env.INCLUDE_CSS_COLOR_NAMES || process.env.TAMAGUI_TARGET === "native") {
  const allNames = require("./names.native").names;
  Object.assign(names, allNames);
}
export {
  names
};
//# sourceMappingURL=names.js.map
